module.exports = __webpack_public_path__ + "img/playbutton1.b5ec4b42.png";